import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'root',
  'heading',
  'carouselRegion',
]);

/** CF-050 — Blog Related Articles. Md+: max 1440px band, 80px horizontal padding (1280px track). Mobile: 20px pl, 0 pr. */
export const blogRelatedArticlesStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: {base: 6, md: 10},
      width: '100%',
      maxWidth: {base: '100%', md: 'container.xxl'},
      mx: {base: undefined, md: 'auto'},
      pl: {base: 5, md: 20},
      pr: {base: 0, md: 20},
      py: {base: 14, md: 20},
      alignSelf: 'stretch',
    },
    heading: {
      alignSelf: 'stretch',
      color: '#262626',
      fontFamily: 'heading',
      fontSize: {base: '28px', md: '40px'},
      fontWeight: '500',
      lineHeight: '120%',
      letterSpacing: {base: '-0.28px', md: '-0.4px'},
      margin: 0,
      px: 0,
    },
    carouselRegion: {
      minWidth: 0,
      overflow: 'hidden',
      position: 'relative',
      width: '100%',
      alignSelf: 'stretch',
    },
  },
});
